import { useEffect, useState } from "react";
import Modal from "@mui/material/Modal";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import { modalStyle } from "components/Utils/ModalStyle";
import ClientsService from "services/clients.service";

export default function UnitCreateModal({ open, building, initialNumber = "", onClose, onCreated }) {
  const [unitNumber, setUnitNumber] = useState("");
  const [floor, setFloor] = useState("");
  const [section, setSection] = useState("");
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open) {
      setUnitNumber(initialNumber);
      setFloor("");
      setSection("");
      setError("");
    }
  }, [open, initialNumber]);

  const save = async (event) => {
    event.preventDefault();
    const number = unitNumber.trim();
    if (!/^\d+$/.test(number) || !floor.trim() || !section.trim() || !building?.id) {
      setError("Enter a numeric unit number, floor and section.");
      return;
    }
    setSaving(true);
    setError("");
    try {
      const response = await ClientsService.insertUnit({
        building: String(building.id),
        unit_number: number,
        floor: floor.trim(),
        section: section.trim(),
      });
      onCreated(response.data);
    } catch (requestError) {
      setError(requestError.response?.data?.status || "Could not create unit.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal open={open} onClose={saving ? undefined : onClose}>
      <MDBox sx={modalStyle}>
        <Card sx={{ overflow: "visible" }}>
          <MDBox p={3} pb={2}>
            <MDTypography variant="h5">Insert New Unit</MDTypography>
            {building?.building_name && <MDTypography variant="caption">{building.building_name}</MDTypography>}
          </MDBox>
          <MDBox component="form" onSubmit={save} pb={3} px={3}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <TextField required fullWidth label="Unit Number" value={unitNumber}
                  inputProps={{ inputMode: "numeric" }}
                  onChange={(event) => {
                    if (/^\d*$/.test(event.target.value)) setUnitNumber(event.target.value);
                  }} />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField required fullWidth label="Floor" value={floor}
                  onChange={(event) => setFloor(event.target.value)} />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField required fullWidth label="Section" value={section}
                  onChange={(event) => setSection(event.target.value)} />
              </Grid>
              {error && <Grid item xs={12}><MDTypography color="error" variant="caption">{error}</MDTypography></Grid>}
              <Grid item xs={12}>
                <MDButton type="submit" color="info" disabled={saving || !building?.id}>Save Data</MDButton>
              </Grid>
            </Grid>
          </MDBox>
        </Card>
      </MDBox>
    </Modal>
  );
}
